/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
module.exports = require("webpack-core/lib/ConcatSource");



//////////////////
// WEBPACK FOOTER
// (webpack)/lib/ConcatSource.js
// module id = 4088
// module chunks = 0